export const HOME_CRUMB = 'Home'
export const PARTNER_REGISTRATION_CRUMB = 'Partner Registration'
export const REGISTRATION_SEARCH_CRUMB = 'Registration Search'
export const REGISTRATION_SEARCH_RESULTS_CRUMB = 'Registration Search Results'
export const REGISTRATION_DETAILS_CRUMB = 'Registration Details'
